import { render, staticRenderFns } from "./TimeSlot.vue?vue&type=template&id=38a56d22&scoped=true"
import script from "./TimeSlot.vue?vue&type=script&lang=js"
export * from "./TimeSlot.vue?vue&type=script&lang=js"
import style0 from "./TimeSlot.vue?vue&type=style&index=0&id=38a56d22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a56d22",
  null
  
)

export default component.exports